export default function WhatTrainingIncludes() {
  const stages = [
    {
      num: '01',
      icon: 'ri-search-eye-line',
      title: 'Диагностика',
      desc: 'Анализ текущих KPI, аудит компетенций менеджеров, выявление сильных и слабых сторон, определение точек роста.'
    },
    {
      num: '02',
      icon: 'ri-file-list-3-line',
      title: 'Подготовка программы',
      desc: 'Разработка индивидуальной программы под задачи бизнеса, отраслевую специфику и уровень подготовки команды.'
    },
    {
      num: '03',
      icon: 'ri-presentation-line',
      title: 'Корпоративный тренинг',
      desc: 'Проведение обучения: 80% практики, реальные кейсы компании, отработка навыков в безопасной среде.'
    },
    {
      num: '04',
      icon: 'ri-tools-fill',
      title: 'Практика',
      desc: 'Ролевые игры, разбор реальных звонков и встреч, отработка скриптов и алгоритмов на материале компании.'
    },
    {
      num: '05',
      icon: 'ri-task-line',
      title: 'Домашние задания',
      desc: 'Закрепление материала между модулями: чек-листы, задания на применение, анализ собственных кейсов.'
    },
    {
      num: '06',
      icon: 'ri-bar-chart-grouped-line',
      title: 'Контроль',
      desc: 'Промежуточные замеры, тестирование знаний, проверка выполнения заданий, обратная связь участникам.'
    },
    {
      num: '07',
      icon: 'ri-user-heart-line',
      title: 'Сопровождение',
      desc: 'Посттренинговые встречи, коучинговые сессии, поддержка внедрения навыков в ежедневную работу.'
    },
    {
      num: '08',
      icon: 'ri-trophy-line',
      title: 'Оценка результатов',
      desc: 'Сравнение KPI до и после обучения, оценка ROI, фиксация достигнутых бизнес-результатов.'
    },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Что включает обучение отдела продаж
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto">
          Системный подход — от диагностики до оценки результатов. Каждый этап важен для достижения устойчивых изменений.
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {stages.map((stage, i) => (
            <div key={i} className="relative bg-gray-50 rounded-xl p-6 hover:bg-teal-50 transition-colors group">
              <div className="text-5xl font-extrabold text-teal-600/15 absolute top-4 right-5 leading-none">{stage.num}</div>
              <div className="w-11 h-11 bg-teal-600 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform relative z-10">
                <i className={`${stage.icon} text-lg text-white`}></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-2 text-sm relative z-10">{stage.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed relative z-10">{stage.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}